import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Fuel } from "lucide-react";
import { OpenStatus } from "./OpenStatus";
import { useContent } from "../context/ContentContext";

const FACEBOOK_URL = "https://www.facebook.com/Stoofvinkeveen";

export const Footer = () => {
  const { get } = useContent();
  const tel = get("bedrijf.telefoon", "0297 - 261 333");
  const email = get("bedrijf.email", "info@stoofvinkeveen.nl");
  return (
  <footer data-testid="footer" className="bg-primary text-white relative overflow-hidden grain">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 relative z-10">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <img src={`${process.env.PUBLIC_URL}/stoof-logo-white.png`} alt="Automobielbedrijf Stoof" className="h-12 w-auto" data-testid="footer-logo" />
          <p className="mt-4 text-white/70 max-w-xs leading-relaxed">
            {get("bedrijf.footer_tagline", "Al jaren uw vertrouwde adres in Vinkeveen voor kwaliteitsoccasions, onderhoud en een eerlijk advies.")}
          </p>
          <a
            href={FACEBOOK_URL} target="_blank" rel="noreferrer" data-testid="footer-facebook"
            aria-label="Bezoek onze Facebook-pagina"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-2.5 text-sm font-semibold hover:bg-white/20 transition-colors"
          >
            <Facebook size={18} /> Volg ons op Facebook
          </a>
          <div className="mt-6">
            <a
              href="https://www.bovag.nl/bovag-certificaat/leden/automobielbedrijf-stoof-vinkeveen/Vinkeveen/00969900"
              target="_blank" rel="noreferrer" data-testid="footer-bovag"
              aria-label="Bekijk ons BOVAG-certificaat"
              className="inline-flex bg-white rounded-lg p-3 hover:shadow-xl transition-shadow"
            >
              <img src={`${process.env.PUBLIC_URL}/bovag-logo.png`} alt="BOVAG-lid — Automobielbedrijf Stoof Vinkeveen" className="h-16 w-auto" />
            </a>
            <p className="mt-2 text-sm font-semibold tracking-wide text-accent" data-testid="bovag-since">Lid sinds 1932</p>
          </div>
        </div>
        <div className="space-y-4">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Contact</p>
          <a href="https://maps.google.com/?q=Herenweg+165+Vinkeveen" target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors">
            <MapPin size={18} className="mt-1 shrink-0" /> {get("bedrijf.adres_regel1", "Herenweg 165")}, {get("bedrijf.adres_regel2", "3645 DK Vinkeveen")}
          </a>
          <a href={`tel:${tel.replace(/[^0-9+]/g, "")}`} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors" data-testid="footer-phone">
            <Phone size={18} /> {tel}
          </a>
          <a href={`mailto:${email}`} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors" data-testid="footer-email">
            <Mail size={18} /> {email}
          </a>
          <div className="pt-2">
            <OpenStatus variant="dark" />
          </div>
          <div className="text-white/70 text-sm leading-relaxed pt-1">
            <p>{get("bedrijf.open_ma_vr", "Ma t/m vr: 07:00 – 18:00")}</p>
            <p>{get("bedrijf.open_za", "Zaterdag: 08:00 – 18:00")}</p>
            <p>{get("bedrijf.open_zo", "Zondag: gesloten")}</p>
          </div>
        </div>
        <div className="space-y-4">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Navigatie</p>
          <div className="flex flex-col gap-2">
            <Link to="/occasions" className="text-white/80 hover:text-white transition-colors">Occasions</Link>
            <Link to="/afspraak" className="text-white/80 hover:text-white transition-colors">Afspraak maken</Link>
            <Link to="/avia" className="text-white/80 hover:text-white transition-colors inline-flex items-center gap-1.5"><Fuel size={14} /> AVIA Tankstation</Link>
            <Link to="/over-ons" className="text-white/80 hover:text-white transition-colors">Over ons</Link>
            <Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact & Proefrit</Link>
            <Link to="/login" className="text-white/50 hover:text-white transition-colors text-sm mt-2">Beheer</Link>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/50">
        <p>© {new Date().getFullYear()} Automobielbedrijf Stoof — Vinkeveen</p>
        <p>{get("bedrijf.footer_slogan", "Kwaliteit • Vertrouwen • Vakmanschap")}</p>
      </div>
    </div>
  </footer>
  );
};
